import { render, staticRenderFns } from "./AppendixPackage.vue?vue&type=template&id=867a0b06&scoped=true"
import script from "./AppendixPackage.vue?vue&type=script&lang=js"
export * from "./AppendixPackage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "867a0b06",
  null
  
)

export default component.exports